export enum BillingContactType {
    Contact = 1,
    OtherContact = 2,
}

export enum BillingContactUsingType {
    Contact = 0,
    Reference = 1,
}

export var BillingContactResources: IBillingContactResource[] = [
    // Chainformation.Ccm.Billing.Model.BillingContactUsingType.Contact
    {
        BillingContactTypes: [
            { Id: BillingContactType.Contact, TextId: 'billing.contact_person' },
            { Id: BillingContactType.OtherContact, TextId: 'billing.other_contact_person' },
        ],
        EmailLabelId: 'billing.contact_person_email',
        PhoneLabelId: 'billing.contact_person_phone',
    },
    // Chainformation.Ccm.Billing.Model.BillingContactUsingType.Reference
    {
        BillingContactTypes: [
            { Id: BillingContactType.Contact, TextId: 'billing.billing_reference' },
            { Id: BillingContactType.OtherContact, TextId: 'billing.other_billing_reference' },
        ],
        EmailLabelId: 'billing.billing_reference_email',
        PhoneLabelId: 'billing.billing_reference_phone',
    },
];

export interface IBillingContactType {
    Id: BillingContactType;
    TextId: string;
}

export interface IBillingContactResource {
    BillingContactTypes: IBillingContactType[];
    EmailLabelId: string;
    PhoneLabelId: string;
}
